const MAX_SEARCH_LENGTH = 200;

export function sanitizeSearchQuery(q: string | undefined): string | undefined {
  if (!q) {
    return undefined;
  }
  // Strip Unicode control (Cc) and format (Cf) characters, e.g. null bytes,
  // zero-width spaces, soft hyphens. Not an injection fix — SDK URL-encodes —
  // but prevents garbage reaching the search index.
  const stripped = q.replace(/[\p{Cc}\p{Cf}]/gu, '').trim();
  if (!stripped) {
    return undefined;
  }
  return stripped.slice(0, MAX_SEARCH_LENGTH);
}
